import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useEquipmentInspectionsReportSettingsUpdate() {
  return useFeatureSettingsUpdate('equipmentInspectionsReport');
}
